import React from 'react';
import { statusColor } from '../utils/helpers';

function StatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${statusColor(status)}`}>
      {status}
    </span>
  );
}

export default StatusBadge;
